export default __webpack_public_path__ + "static/media/Footpad's Helm of the Hidden Palace.b2bc7e37.jpg";